"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Social = exports.SOCIAL_TYPE = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _enum = require("b2b-components/utils/enum");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Social.scss");
let SOCIAL_TYPE = exports.SOCIAL_TYPE = /*#__PURE__*/function (SOCIAL_TYPE) {
  SOCIAL_TYPE["facebook"] = "facebook";
  SOCIAL_TYPE["instagram"] = "instagram";
  SOCIAL_TYPE["linkedin"] = "linkedin";
  SOCIAL_TYPE["twitter"] = "twitter";
  SOCIAL_TYPE["youtube"] = "youtube";
  return SOCIAL_TYPE;
}({});
const Social = props => {
  const {
    className
  } = props;
  const rootClassName = (0, _classnames.default)('cds-FooterSubGroup', 'cds-FooterSubGroup--Social', className);
  const links = (0, _enum.getEnumValues)(SOCIAL_TYPE).filter(social => !!props[social]).map(social => /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-FooterSocial-Link",
    href: props[social],
    key: social,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-FooterSocial-Icon",
    name: `IconSocial${(0, _upperCase.upperCaseFirst)(social)}`
  })));
  if (links.length <= 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, links);
};
exports.Social = Social;
//# sourceMappingURL=Social.js.map